import React from 'react'
import './styles/Loading.css'
const Loading = () =>{
  return(
    <div className="loader">Loading...</div>
  )

}

export default Loading